export const FIELD_TYPES = [
  'text',
  'textarea',
  'select',
  'checkbox',
  'radio',
  'file',
  'email'
]